(function () {
  function initVariantTreeInfo() {
    const blocks = document.querySelectorAll('[data-variant-tree-info]');

    if (!blocks.length) return;

    blocks.forEach(function (block) {
      const sectionId = block.getAttribute('data-section-id');
      const dataScript = document.querySelector(
        '[data-variant-tree-info-json="' + sectionId + '"]'
      );

      if (!dataScript) return;

      let variantInfo = {};

      try {
        variantInfo = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.warn('Variant tree info JSON could not be parsed:', error);
        return;
      }

      function getVariantIdFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
      }

      function getSelectedVariantIdFromForm() {
        const form = block.closest('section') || document;

        const variantInput =
          form.querySelector('input[name="id"]:checked') ||
          form.querySelector('select[name="id"]') ||
          form.querySelector('input[name="id"]');

        return variantInput ? variantInput.value : null;
      }

      function updateTreeInfo(variantId) {
        if (!variantId || !variantInfo[variantId]) {
          block.innerHTML = '';
          return;
        }

        block.innerHTML = variantInfo[variantId];
      }

      function updateFromCurrentSelection() {
        const selectedVariantId = getSelectedVariantIdFromForm() || getVariantIdFromUrl();

        updateTreeInfo(String(selectedVariantId));
      }

      document.addEventListener('change', function (event) {
        const target = event.target;

        if (!target) return;

        const isVariantControl =
          target.matches('input[type="radio"]') ||
          target.matches('select') ||
          target.matches('input[name="id"]');

        if (!isVariantControl) return;

        window.setTimeout(updateFromCurrentSelection, 50);
      });

      document.addEventListener('variant:change', function (event) {
        const variant = event.detail && event.detail.variant;

        if (!variant || !variant.id) return;

        updateTreeInfo(String(variant.id));
      });

      document.addEventListener('variant-change', function (event) {
        const variant = event.detail && event.detail.variant;

        if (!variant || !variant.id) return;

        updateTreeInfo(String(variant.id));
      });

      updateFromCurrentSelection();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantTreeInfo);
  } else {
    initVariantTreeInfo();
  }
})();